module.exports = __webpack_public_path__ + "img/subject.f7c3a772.png";